/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Session_Position_TakenInputs */

const en_us2_plan_session_position_taken = /** @type {(inputs: Plan_Session_Position_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That workout already has a place in the plan.`)
};

const pt_br2_plan_session_position_taken = /** @type {(inputs: Plan_Session_Position_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse treino já tem um lugar no plano.`)
};

const es_419_plan_session_position_taken = /** @type {(inputs: Plan_Session_Position_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese entrenamiento ya tiene un lugar en el plan.`)
};

const pt_pt2_plan_session_position_taken = /** @type {(inputs: Plan_Session_Position_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse treino já tem um lugar no plano.`)
};

const fr_fr2_plan_session_position_taken = /** @type {(inputs: Plan_Session_Position_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette séance a déjà une place dans le programme.`)
};

const de_de2_plan_session_position_taken = /** @type {(inputs: Plan_Session_Position_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Training hat schon einen Platz im Plan.`)
};

const it_it2_plan_session_position_taken = /** @type {(inputs: Plan_Session_Position_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quell'allenamento ha già un posto nella scheda.`)
};

/**
* | output |
* | --- |
* | "That workout already has a place in the plan." |
*
* @param {Plan_Session_Position_TakenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_session_position_taken = /** @type {((inputs?: Plan_Session_Position_TakenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Session_Position_TakenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_session_position_taken(inputs)
	if (locale === "es-419") return es_419_plan_session_position_taken(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_session_position_taken(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_session_position_taken(inputs)
	if (locale === "de-DE") return de_de2_plan_session_position_taken(inputs)
	if (locale === "it-IT") return it_it2_plan_session_position_taken(inputs)
	return en_us2_plan_session_position_taken(inputs)
});
export { plan_session_position_taken as "plan.session_position_taken" }